import { ITranslations } from '@kurtosys/types/common/ITranslations.js';
import { TDefaultTranslations } from '@kurtosys/types/defaultTranslations/index.js';

import { replacePlaceholders } from '../commonUtils/replacePlaceholders.js';

export class TranslationHelper {
	targetTranslations: ITranslations = {};
	fallbackTranslations: ITranslations = {};
	defaultTranslations?: TDefaultTranslations = {};
	constructor(
		targetTranslations: ITranslations,
		fallbackTranslations: ITranslations,
		defaultTranslations?: TDefaultTranslations,
	) {
		this.targetTranslations = targetTranslations;
		this.fallbackTranslations = fallbackTranslations;
		this.defaultTranslations = defaultTranslations || {};
		this.translate = this.translate.bind(this);
	}
	translateStatic<T extends keyof TDefaultTranslations>(
		key: TDefaultTranslations[T]['key'],
		placeholders?: TDefaultTranslations[T]['placeholders'],
		defaultText?: string,
	): string {
		return this.translate(key, placeholders, defaultText);
	}
	translate(key: string, placeholders?: unknown, defaultText?: string): string {
		let translation = this.getTranslation(key);

		if (!translation && defaultText) {
			translation = this.getTranslation(defaultText) || defaultText;
		}
		if (!translation) {
			translation = key;
		}

		return placeholders ? replacePlaceholders({ values: placeholders, text: translation }) : translation;
	}
	getTranslation(key: string): string {
		return this.targetTranslations[key] || this.fallbackTranslations[key] || this.defaultTranslations[key]?.default;
	}
	// This method is used by ksys-app-components to update the default translations
	updateDefaultTranslations(defaultTranslations: TDefaultTranslations): void {
		this.defaultTranslations = { ...this.defaultTranslations, ...defaultTranslations };
	}
}
